// // // import React, { useEffect, useState, useCallback } from "react";
// // // import {
// // //   Table, Button, Input, InputNumber, Switch, Modal, Form,
// // //   message, Tooltip, Popconfirm, Space, Tag, Typography,
// // // } from "antd";
// // // import {
// // //   PlusOutlined, SaveOutlined, EditOutlined, DeleteOutlined,
// // //   LockOutlined,
// // // } from "@ant-design/icons";
// // // import { getWriteParameters, saveWriteParameters } from "../service/Writecontrol";

// // // const { Text } = Typography;

// // // /**
// // //  * Tab displayed on the Asset detail / edit page.
// // //  * Lets the customer select which parameters are allowed for MQTT write operations.
// // //  *
// // //  * Props:
// // //  *   assetUuid        – UUID of the asset
// // //  *   sampleJson       – parsed sample JSON from the asset (used to suggest param keys)
// // //  */
// // // const WritableParametersTab = ({ assetUuid, sampleJson }) => {
// // //   const [params, setParams] = useState([]);
// // //   const [loading, setLoading] = useState(false);
// // //   const [saving, setSaving] = useState(false);
// // //   const [modalOpen, setModalOpen] = useState(false);
// // //   const [editingParam, setEditingParam] = useState(null);
// // //   const [form] = Form.useForm();

// // //   // ── Derive available keys from sampleJson ─────────────────────────────────
// // //   const getLeafKeys = useCallback((obj, prefix = "") => {
// // //     if (!obj || typeof obj !== "object") return [];
// // //     return Object.entries(obj).flatMap(([k, v]) => {
// // //       const path = prefix ? `${prefix}_${k}` : k;
// // //       return typeof v === "object" && v !== null
// // //         ? getLeafKeys(v, path)
// // //         : [path];
// // //     });
// // //   }, []);

// // //   const availableKeys = React.useMemo(() => {
// // //     try {
// // //       const parsed =
// // //         typeof sampleJson === "string" ? JSON.parse(sampleJson) : sampleJson || {};
// // //       return getLeafKeys(parsed);
// // //     } catch {
// // //       return [];
// // //     }
// // //   }, [sampleJson, getLeafKeys]);

// // //   // ── Load existing configuration ──────────────────────────────────────────
// // //   const loadParams = useCallback(async () => {
// // //     if (!assetUuid) return;
// // //     setLoading(true);
// // //     try {
// // //       const res = await getWriteParameters(assetUuid);
// // //       setParams(res?.data?.data || []);
// // //     } catch (err) {
// // //       message.error("Failed to load writable parameters");
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   }, [assetUuid]);

// // //   useEffect(() => {
// // //     loadParams();
// // //   }, [loadParams]);

// // //   // ── Save all parameters ───────────────────────────────────────────────────
// // //   const handleSave = async () => {
// // //     setSaving(true);
// // //     try {
// // //       await saveWriteParameters(assetUuid, params);
// // //       message.success("Writable parameters saved");
// // //     } catch (err) {
// // //       message.error("Failed to save");
// // //     } finally {
// // //       setSaving(false);
// // //     }
// // //   };

// // //   // ── Add / edit modal ──────────────────────────────────────────────────────
// // //   const openAdd = () => {
// // //     setEditingParam(null);
// // //     form.resetFields();
// // //     form.setFieldsValue({ enabled: true });
// // //     setModalOpen(true);
// // //   };

// // //   const openEdit = (record) => {
// // //     setEditingParam(record);
// // //     form.setFieldsValue(record);
// // //     setModalOpen(true);
// // //   };

// // //   const handleModalOk = async () => {
// // //     const values = await form.validateFields();
// // //     if (editingParam) {
// // //       // Update existing
// // //       setParams((prev) =>
// // //         prev.map((p) =>
// // //           p.parameterKey === editingParam.parameterKey ? { ...p, ...values } : p
// // //         )
// // //       );
// // //     } else {
// // //       // Check duplicate
// // //       if (params.some((p) => p.parameterKey === values.parameterKey)) {
// // //         message.warning("Parameter key already added");
// // //         return;
// // //       }
// // //       setParams((prev) => [...prev, { ...values, enabled: values.enabled ?? true }]);
// // //     }
// // //     setModalOpen(false);
// // //   };

// // //   const handleDelete = (parameterKey) => {
// // //     setParams((prev) => prev.filter((p) => p.parameterKey !== parameterKey));
// // //   };

// // //   const toggleEnabled = (parameterKey, enabled) => {
// // //     setParams((prev) =>
// // //       prev.map((p) => (p.parameterKey === parameterKey ? { ...p, enabled } : p))
// // //     );
// // //   };

// // //   // ── Table columns ─────────────────────────────────────────────────────────
// // //   const columns = [
// // //     {
// // //       title: "Parameter Key",
// // //       dataIndex: "parameterKey",
// // //       key: "parameterKey",
// // //       render: (v) => <Text code>{v}</Text>,
// // //     },
// // //     {
// // //       title: "Display Name",
// // //       dataIndex: "displayName",
// // //       key: "displayName",
// // //     },
// // //     {
// // //       title: "Unit",
// // //       dataIndex: "unit",
// // //       key: "unit",
// // //       render: (v) => v ? <Tag>{v}</Tag> : "—",
// // //     },
// // //     {
// // //       title: "Min",
// // //       dataIndex: "minValue",
// // //       key: "minValue",
// // //       render: (v) => (v != null ? v : "—"),
// // //     },
// // //     {
// // //       title: "Max",
// // //       dataIndex: "maxValue",
// // //       key: "maxValue",
// // //       render: (v) => (v != null ? v : "—"),
// // //     },
// // //     {
// // //       title: "Enabled",
// // //       dataIndex: "enabled",
// // //       key: "enabled",
// // //       render: (v, record) => (
// // //         <Switch
// // //           checked={v}
// // //           size="small"
// // //           onChange={(checked) => toggleEnabled(record.parameterKey, checked)}
// // //         />
// // //       ),
// // //     },
// // //     {
// // //       title: "Actions",
// // //       key: "actions",
// // //       render: (_, record) => (
// // //         <Space>
// // //           <Tooltip title="Edit">
// // //             <Button
// // //               icon={<EditOutlined />}
// // //               size="small"
// // //               onClick={() => openEdit(record)}
// // //             />
// // //           </Tooltip>
// // //           <Popconfirm
// // //             title="Remove this writable parameter?"
// // //             onConfirm={() => handleDelete(record.parameterKey)}
// // //             okText="Remove"
// // //             okButtonProps={{ danger: true }}
// // //           >
// // //             <Tooltip title="Remove">
// // //               <Button icon={<DeleteOutlined />} size="small" danger />
// // //             </Tooltip>
// // //           </Popconfirm>
// // //         </Space>
// // //       ),
// // //     },
// // //   ];

// // //   return (
// // //     <div>
// // //       {/* Header */}
// // //       <div
// // //         style={{
// // //           display: "flex",
// // //           justifyContent: "space-between",
// // //           alignItems: "center",
// // //           marginBottom: 16,
// // //           padding: "12px 16px",
// // //           background: "#fff7e6",
// // //           borderRadius: 8,
// // //           border: "1px solid #ffd591",
// // //         }}
// // //       >
// // //         <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
// // //           <LockOutlined style={{ color: "#fa8c16", fontSize: 18 }} />
// // //           <div>
// // //             <Text strong>Write-Permitted Parameters</Text>
// // //             <br />
// // //             <Text type="secondary" style={{ fontSize: 12 }}>
// // //               Only parameters listed here can be written via MQTT. This is a
// // //               security boundary — add carefully.
// // //             </Text>
// // //           </div>
// // //         </div>
// // //         <Space>
// // //           <Button icon={<PlusOutlined />} onClick={openAdd}>
// // //             Add Parameter
// // //           </Button>
// // //           <Button
// // //             type="primary"
// // //             icon={<SaveOutlined />}
// // //             loading={saving}
// // //             onClick={handleSave}
// // //             disabled={params.length === 0}
// // //           >
// // //             Save Configuration
// // //           </Button>
// // //         </Space>
// // //       </div>

// // //       {/* Table */}
// // //       <Table
// // //         dataSource={params}
// // //         columns={columns}
// // //         rowKey="parameterKey"
// // //         loading={loading}
// // //         pagination={false}
// // //         size="small"
// // //         locale={{ emptyText: "No writable parameters configured. Click 'Add Parameter' to start." }}
// // //       />

// // //       {/* Add/Edit Modal */}
// // //       <Modal
// // //         title={editingParam ? "Edit Writable Parameter" : "Add Writable Parameter"}
// // //         open={modalOpen}
// // //         onOk={handleModalOk}
// // //         onCancel={() => setModalOpen(false)}
// // //         okText="Save"
// // //         destroyOnClose
// // //       >
// // //         <Form form={form} layout="vertical">
// // //           <Form.Item
// // //             name="parameterKey"
// // //             label="Parameter Key"
// // //             rules={[{ required: true, message: "Required" }]}
// // //             extra={
// // //               availableKeys.length > 0
// // //                 ? `Detected keys from sample JSON: ${availableKeys.slice(0, 6).join(", ")}${availableKeys.length > 6 ? " …" : ""}`
// // //                 : undefined
// // //             }
// // //           >
// // //             <Input
// // //               placeholder="e.g. temperature"
// // //               disabled={!!editingParam}
// // //               list="available-keys"
// // //             />
// // //             {availableKeys.length > 0 && (
// // //               <datalist id="available-keys">
// // //                 {availableKeys.map((k) => (
// // //                   <option key={k} value={k} />
// // //                 ))}
// // //               </datalist>
// // //             )}
// // //           </Form.Item>

// // //           <Form.Item name="displayName" label="Display Name">
// // //             <Input placeholder="e.g. Furnace Temperature" />
// // //           </Form.Item>

// // //           <Form.Item name="unit" label="Unit">
// // //             <Input placeholder="e.g. °C, bar, rpm" style={{ width: 160 }} />
// // //           </Form.Item>

// // //           <div style={{ display: "flex", gap: 16 }}>
// // //             <Form.Item name="minValue" label="Min Value" style={{ flex: 1 }}>
// // //               <InputNumber style={{ width: "100%" }} placeholder="Optional" />
// // //             </Form.Item>
// // //             <Form.Item name="maxValue" label="Max Value" style={{ flex: 1 }}>
// // //               <InputNumber style={{ width: "100%" }} placeholder="Optional" />
// // //             </Form.Item>
// // //           </div>

// // //           <Form.Item name="enabled" label="Enabled" valuePropName="checked">
// // //             <Switch />
// // //           </Form.Item>
// // //         </Form>
// // //       </Modal>
// // //     </div>
// // //   );
// // // };

// // // export default WritableParametersTab;

// // import React, { useEffect, useState, useCallback, useMemo } from "react";
// // import {
// //   Table, Button, Input, InputNumber, Switch, Modal, Form,
// //   message, Tooltip, Popconfirm, Space, Tag, Typography, Select,
// // } from "antd";
// // import {
// //   PlusOutlined, SaveOutlined, EditOutlined, DeleteOutlined,
// //   LockOutlined,
// // } from "@ant-design/icons";
// // import { getWriteParameters, saveWriteParameters } from "../service/Writecontrol";

// // const { Text } = Typography;
// // const { Option } = Select;

// // // 🔧 Helper function (moved outside)
// // const getLeaves = (obj, prefix = "") => {
// //   if (!obj || typeof obj !== "object") return [];

// //   return Object.entries(obj).flatMap(([k, v]) => {
// //     const path = prefix ? `${prefix}.${k}` : k;
// //     return typeof v === "object" && v !== null
// //       ? getLeaves(v, path)
// //       : [path];
// //   });
// // };

// // const WritableParametersTab = ({ assetUuid, sampleJson }) => {
// //   const [params, setParams] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [saving, setSaving] = useState(false);
// //   const [modalOpen, setModalOpen] = useState(false);
// //   const [editingParam, setEditingParam] = useState(null);
// //   const [form] = Form.useForm();

// //   // ✅ Fixed useMemo
// //   const availableKeys = useMemo(() => {
// //     try {
// //       const parsed =
// //         typeof sampleJson === "string"
// //           ? JSON.parse(sampleJson)
// //           : sampleJson || {};

// //       return getLeaves(parsed).filter((k) => k !== "timestamp");
// //     } catch {
// //       return [];
// //     }
// //   }, [sampleJson]);

// //   // ── Load existing configuration ──────────────────────────────────────────
// //   const loadParams = useCallback(async () => {
// //     if (!assetUuid) return;

// //     setLoading(true);
// //     try {
// //       const res = await getWriteParameters(assetUuid);
// //       setParams(res?.data?.data || []);
// //     } catch {
// //       message.error("Failed to load writable parameters");
// //     } finally {
// //       setLoading(false);
// //     }
// //   }, [assetUuid]);

// //   useEffect(() => {
// //     loadParams();
// //   }, [loadParams]);

// //   // ── Save all parameters ───────────────────────────────────────────────────
// //   const handleSave = async () => {
// //     setSaving(true);
// //     try {
// //       await saveWriteParameters(assetUuid, params);
// //       message.success("Writable parameters saved");
// //     } catch {
// //       message.error("Failed to save");
// //     } finally {
// //       setSaving(false);
// //     }
// //   };

// //   // ── Modal handlers ──────────────────────────────────────────────────────
// //   const openAdd = () => {
// //     setEditingParam(null);
// //     form.resetFields();
// //     form.setFieldsValue({ enabled: true });
// //     setModalOpen(true);
// //   };

// //   const openEdit = (record) => {
// //     setEditingParam(record);
// //     form.setFieldsValue(record);
// //     setModalOpen(true);
// //   };

// //   const handleModalOk = async () => {
// //     const values = await form.validateFields();

// //     if (editingParam) {
// //       setParams((prev) =>
// //         prev.map((p) =>
// //           p.parameterKey === editingParam.parameterKey
// //             ? { ...p, ...values }
// //             : p
// //         )
// //       );
// //     } else {
// //       if (params.some((p) => p.parameterKey === values.parameterKey)) {
// //         message.warning("Parameter key already added");
// //         return;
// //       }

// //       setParams((prev) => [
// //         ...prev,
// //         { ...values, enabled: values.enabled ?? true },
// //       ]);
// //     }

// //     setModalOpen(false);
// //   };

// //   const handleDelete = (parameterKey) => {
// //     setParams((prev) =>
// //       prev.filter((p) => p.parameterKey !== parameterKey)
// //     );
// //   };

// //   const toggleEnabled = (parameterKey, enabled) => {
// //     setParams((prev) =>
// //       prev.map((p) =>
// //         p.parameterKey === parameterKey ? { ...p, enabled } : p
// //       )
// //     );
// //   };

// //   // ── Table columns ─────────────────────────────────────────────────────────
// //   const columns = [
// //     {
// //       title: "Parameter Key",
// //       dataIndex: "parameterKey",
// //       key: "parameterKey",
// //       render: (v) => <Text code>{v}</Text>,
// //     },
// //     {
// //       title: "Display Name",
// //       dataIndex: "displayName",
// //     },
// //     {
// //       title: "Unit",
// //       dataIndex: "unit",
// //       render: (v) => (v ? <Tag>{v}</Tag> : "—"),
// //     },
// //     {
// //       title: "Min",
// //       dataIndex: "minValue",
// //       render: (v) => (v != null ? v : "—"),
// //     },
// //     {
// //       title: "Max",
// //       dataIndex: "maxValue",
// //       render: (v) => (v != null ? v : "—"),
// //     },
// //     {
// //       title: "Enabled",
// //       dataIndex: "enabled",
// //       render: (v, record) => (
// //         <Switch
// //           checked={v}
// //           size="small"
// //           onChange={(checked) =>
// //             toggleEnabled(record.parameterKey, checked)
// //           }
// //         />
// //       ),
// //     },
// //     {
// //       title: "Actions",
// //       render: (_, record) => (
// //         <Space>
// //           <Tooltip title="Edit">
// //             <Button
// //               icon={<EditOutlined />}
// //               size="small"
// //               onClick={() => openEdit(record)}
// //             />
// //           </Tooltip>

// //           <Popconfirm
// //             title="Remove this writable parameter?"
// //             onConfirm={() => handleDelete(record.parameterKey)}
// //             okText="Remove"
// //             okButtonProps={{ danger: true }}
// //           >
// //             <Tooltip title="Remove">
// //               <Button
// //                 icon={<DeleteOutlined />}
// //                 size="small"
// //                 danger
// //               />
// //             </Tooltip>
// //           </Popconfirm>
// //         </Space>
// //       ),
// //     },
// //   ];

// //   return (
// //     <div>
// //       {/* Header */}
// //       <div
// //         style={{
// //           display: "flex",
// //           justifyContent: "space-between",
// //           alignItems: "center",
// //           marginBottom: 16,
// //           padding: "12px 16px",
// //           background: "#fff7e6",
// //           borderRadius: 8,
// //           border: "1px solid #ffd591",
// //         }}
// //       >
// //         <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
// //           <LockOutlined style={{ color: "#fa8c16", fontSize: 18 }} />
// //           <div>
// //             <Text strong>Write-Permitted Parameters</Text>
// //             <br />
// //             <Text type="secondary" style={{ fontSize: 12 }}>
// //               Only parameters listed here can be written via MQTT.
// //             </Text>
// //           </div>
// //         </div>

// //         <Space>
// //           <Button icon={<PlusOutlined />} onClick={openAdd}>
// //             Add Parameter
// //           </Button>

// //           <Button
// //             type="primary"
// //             icon={<SaveOutlined />}
// //             loading={saving}
// //             onClick={handleSave}
// //             disabled={params.length === 0}
// //           >
// //             Save Configuration
// //           </Button>
// //         </Space>
// //       </div>

// //       {/* Table */}
// //       <Table
// //         dataSource={params}
// //         columns={columns}
// //         rowKey="parameterKey"
// //         loading={loading}
// //         pagination={false}
// //         size="small"
// //         locale={{
// //           emptyText:
// //             "No writable parameters configured. Click 'Add Parameter' to start.",
// //         }}
// //       />

// //       {/* Modal */}
// //       <Modal
// //         title={
// //           editingParam
// //             ? "Edit Writable Parameter"
// //             : "Add Writable Parameter"
// //         }
// //         open={modalOpen}
// //         onOk={handleModalOk}
// //         onCancel={() => setModalOpen(false)}
// //         okText="Save"
// //         destroyOnClose
// //       >
// //         <Form form={form} layout="vertical">
// //           <Form.Item
// //             name="parameterKey"
// //             label="Parameter Key"
// //             rules={[{ required: true, message: "Required" }]}
// //             extra={
// //               availableKeys.length === 0
// //                 ? "No sampleJson keys detected — type manually"
// //                 : undefined
// //             }
// //           >
// //             {availableKeys.length > 0 ? (
// //               <Select
// //                 placeholder="Select parameter"
// //                 disabled={!!editingParam}
// //                 showSearch
// //                 optionFilterProp="children"
// //                 onChange={(key) => {
// //                   const last = key.split(".").pop();
// //                   form.setFieldsValue({
// //                     displayName:
// //                       form.getFieldValue("displayName") || last,
// //                   });
// //                 }}
// //               >
// //                 {availableKeys
// //                   .filter(
// //                     (k) =>
// //                       !params.some(
// //                         (p) =>
// //                           p.parameterKey === k &&
// //                           p.parameterKey !== editingParam?.parameterKey
// //                       )
// //                   )
// //                   .map((k) => (
// //                     <Option key={k} value={k}>
// //                       {k}
// //                     </Option>
// //                   ))}
// //               </Select>
// //             ) : (
// //               <Input placeholder="e.g. Set_Value.v" />
// //             )}
// //           </Form.Item>

// //           <Form.Item name="displayName" label="Display Name">
// //             <Input />
// //           </Form.Item>

// //           <Form.Item name="unit" label="Unit">
// //             <Input />
// //           </Form.Item>

// //           <div style={{ display: "flex", gap: 16 }}>
// //             <Form.Item name="minValue" label="Min Value" style={{ flex: 1 }}>
// //               <InputNumber style={{ width: "100%" }} />
// //             </Form.Item>

// //             <Form.Item name="maxValue" label="Max Value" style={{ flex: 1 }}>
// //               <InputNumber style={{ width: "100%" }} />
// //             </Form.Item>
// //           </div>

// //           <Form.Item name="enabled" label="Enabled" valuePropName="checked">
// //             <Switch />
// //           </Form.Item>
// //         </Form>
// //       </Modal>
// //     </div>
// //   );
// // };

// // export default WritableParametersTab;
// import React, { useEffect, useState, useCallback } from "react";
// import {
//   Table, Button, Input, InputNumber, Switch, Modal, Form,
//   message, Tooltip, Popconfirm, Space, Tag, Typography,
// } from "antd";
// import {
//   PlusOutlined, SaveOutlined, EditOutlined, DeleteOutlined,
//   LockOutlined,
// } from "@ant-design/icons";
// import { getWriteParameters, saveWriteParameters } from "../service/Writecontrol";

// const { Text } = Typography;

// /**
//  * Tab displayed on the Asset detail / edit page.
//  * Lets the customer select which parameters are allowed for MQTT write operations.
//  *
//  * Props:
//  *   assetUuid        – UUID of the asset
//  *   sampleJson       – parsed sample JSON from the asset (used to suggest param keys)
//  */
// const WritableParametersTab = ({ assetUuid, sampleJson }) => {
//   const [params, setParams] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);
//   const [modalOpen, setModalOpen] = useState(false);
//   const [editingParam, setEditingParam] = useState(null);
//   const [form] = Form.useForm();

//   // ── Derive available keys from sampleJson ─────────────────────────────────
//   const getLeafKeys = useCallback((obj, prefix = "") => {
//     if (!obj || typeof obj !== "object") return [];
//     return Object.entries(obj).flatMap(([k, v]) => {
//       const path = prefix ? `${prefix}_${k}` : k;
//       return typeof v === "object" && v !== null
//         ? getLeafKeys(v, path)
//         : [path];
//     });
//   }, []);

//   const availableKeys = React.useMemo(() => {
//     try {
//       const parsed =
//         typeof sampleJson === "string" ? JSON.parse(sampleJson) : sampleJson || {};
//       return getLeafKeys(parsed);
//     } catch {
//       return [];
//     }
//   }, [sampleJson, getLeafKeys]);

//   // ── Load existing configuration ──────────────────────────────────────────
//   const loadParams = useCallback(async () => {
//     if (!assetUuid) return;
//     setLoading(true);
//     try {
//       const res = await getWriteParameters(assetUuid);
//       setParams(res?.data?.data || []);
//     } catch (err) {
//       message.error("Failed to load writable parameters");
//     } finally {
//       setLoading(false);
//     }
//   }, [assetUuid]);

//   useEffect(() => {
//     loadParams();
//   }, [loadParams]);

//   // ── Save all parameters ───────────────────────────────────────────────────
//   const handleSave = async () => {
//     setSaving(true);
//     try {
//       await saveWriteParameters(assetUuid, params);
//       message.success("Writable parameters saved");
//     } catch (err) {
//       message.error("Failed to save");
//     } finally {
//       setSaving(false);
//     }
//   };

//   // ── Add / edit modal ──────────────────────────────────────────────────────
//   const openAdd = () => {
//     setEditingParam(null);
//     form.resetFields();
//     form.setFieldsValue({ enabled: true });
//     setModalOpen(true);
//   };

//   const openEdit = (record) => {
//     setEditingParam(record);
//     form.setFieldsValue(record);
//     setModalOpen(true);
//   };

//   const handleModalOk = async () => {
//     const values = await form.validateFields();
//     let newParams;
//     if (editingParam) {
//       newParams = params.map((p) =>
//         p.parameterKey === editingParam.parameterKey ? { ...p, ...values } : p
//       );
//     } else {
//       if (params.some((p) => p.parameterKey === values.parameterKey)) {
//         message.warning("Parameter key already added");
//         return;
//       }
//       newParams = [...params, { ...values, enabled: values.enabled ?? true }];
//     }
//     setParams(newParams);
//     setModalOpen(false);
//     // Auto-save immediately after add/edit
//     setSaving(true);
//     try {
//       await saveWriteParameters(assetUuid, newParams);
//       message.success("Writable parameter saved");
//     } catch (err) {
//       message.error("Failed to save: " + (err?.response?.data?.message || err.message));
//     } finally {
//       setSaving(false);
//     }
//   };

//   const handleDelete = async (parameterKey) => {
//     const newParams = params.filter((p) => p.parameterKey !== parameterKey);
//     setParams(newParams);
//     // Auto-save after delete
//     setSaving(true);
//     try {
//       await saveWriteParameters(assetUuid, newParams);
//       message.success("Parameter removed");
//     } catch (err) {
//       message.error("Failed to save: " + (err?.response?.data?.message || err.message));
//     } finally {
//       setSaving(false);
//     }
//   };

//   const toggleEnabled = async (parameterKey, enabled) => {
//     const newParams = params.map((p) =>
//       p.parameterKey === parameterKey ? { ...p, enabled } : p
//     );
//     setParams(newParams);
//     // Auto-save after toggle
//     setSaving(true);
//     try {
//       await saveWriteParameters(assetUuid, newParams);
//       message.success(enabled ? "Parameter enabled" : "Parameter disabled");
//     } catch (err) {
//       message.error("Failed to save: " + (err?.response?.data?.message || err.message));
//     } finally {
//       setSaving(false);
//     }
//   };

//   // ── Table columns ─────────────────────────────────────────────────────────
//   const columns = [
//     {
//       title: "Parameter Key",
//       dataIndex: "parameterKey",
//       key: "parameterKey",
//       render: (v) => <Text code>{v}</Text>,
//     },
//     {
//       title: "Display Name",
//       dataIndex: "displayName",
//       key: "displayName",
//     },
//     {
//       title: "Unit",
//       dataIndex: "unit",
//       key: "unit",
//       render: (v) => v ? <Tag>{v}</Tag> : "—",
//     },
//     {
//       title: "Min",
//       dataIndex: "minValue",
//       key: "minValue",
//       render: (v) => (v != null ? v : "—"),
//     },
//     {
//       title: "Max",
//       dataIndex: "maxValue",
//       key: "maxValue",
//       render: (v) => (v != null ? v : "—"),
//     },
//     {
//       title: "Enabled",
//       dataIndex: "enabled",
//       key: "enabled",
//       render: (v, record) => (
//         <Switch
//           checked={v}
//           size="small"
//           onChange={(checked) => toggleEnabled(record.parameterKey, checked)}
//         />
//       ),
//     },
//     {
//       title: "Actions",
//       key: "actions",
//       render: (_, record) => (
//         <Space>
//           <Tooltip title="Edit">
//             <Button
//               icon={<EditOutlined />}
//               size="small"
//               onClick={() => openEdit(record)}
//             />
//           </Tooltip>
//           <Popconfirm
//             title="Remove this writable parameter?"
//             onConfirm={() => handleDelete(record.parameterKey)}
//             okText="Remove"
//             okButtonProps={{ danger: true }}
//           >
//             <Tooltip title="Remove">
//               <Button icon={<DeleteOutlined />} size="small" danger />
//             </Tooltip>
//           </Popconfirm>
//         </Space>
//       ),
//     },
//   ];

//   return (
//     <div>
//       {/* Header */}
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           marginBottom: 16,
//           padding: "12px 16px",
//           background: "#fff7e6",
//           borderRadius: 8,
//           border: "1px solid #ffd591",
//         }}
//       >
//         <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
//           <LockOutlined style={{ color: "#fa8c16", fontSize: 18 }} />
//           <div>
//             <Text strong>Write-Permitted Parameters</Text>
//             <br />
//             <Text type="secondary" style={{ fontSize: 12 }}>
//               Only parameters listed here can be written via MQTT. This is a
//               security boundary — add carefully.
//             </Text>
//           </div>
//         </div>
//         <Space>
//           <Button icon={<PlusOutlined />} onClick={openAdd}>
//             Add Parameter
//           </Button>
//           {saving && (
//             <Text type="secondary" style={{ fontSize: 12 }}>
//               <SaveOutlined spin /> Saving...
//             </Text>
//           )}
//         </Space>
//       </div>

//       {/* Table */}
//       <Table
//         dataSource={params}
//         columns={columns}
//         rowKey="parameterKey"
//         loading={loading}
//         pagination={false}
//         size="small"
//         locale={{ emptyText: "No writable parameters configured. Click 'Add Parameter' to start." }}
//       />

//       {/* Add/Edit Modal */}
//       <Modal
//         title={editingParam ? "Edit Writable Parameter" : "Add Writable Parameter"}
//         open={modalOpen}
//         onOk={handleModalOk}
//         onCancel={() => setModalOpen(false)}
//         okText="Save"
//         destroyOnClose
//       >
//         <Form form={form} layout="vertical">
//           <Form.Item
//             name="parameterKey"
//             label="Parameter Key"
//             rules={[{ required: true, message: "Required" }]}
//             extra={
//               availableKeys.length > 0
//                 ? `Detected keys from sample JSON: ${availableKeys.slice(0, 6).join(", ")}${availableKeys.length > 6 ? " …" : ""}`
//                 : undefined
//             }
//           >
//             <Input
//               placeholder="e.g. temperature"
//               disabled={!!editingParam}
//               list="available-keys"
//             />
//             {availableKeys.length > 0 && (
//               <datalist id="available-keys">
//                 {availableKeys.map((k) => (
//                   <option key={k} value={k} />
//                 ))}
//               </datalist>
//             )}
//           </Form.Item>

//           <Form.Item name="displayName" label="Display Name">
//             <Input placeholder="e.g. Furnace Temperature" />
//           </Form.Item>

//           <Form.Item name="unit" label="Unit">
//             <Input placeholder="e.g. °C, bar, rpm" style={{ width: 160 }} />
//           </Form.Item>

//           <div style={{ display: "flex", gap: 16 }}>
//             <Form.Item name="minValue" label="Min Value" style={{ flex: 1 }}>
//               <InputNumber style={{ width: "100%" }} placeholder="Optional" />
//             </Form.Item>
//             <Form.Item name="maxValue" label="Max Value" style={{ flex: 1 }}>
//               <InputNumber style={{ width: "100%" }} placeholder="Optional" />
//             </Form.Item>
//           </div>

//           <Form.Item name="enabled" label="Enabled" valuePropName="checked">
//             <Switch />
//           </Form.Item>
//         </Form>
//       </Modal>
//     </div>
//   );
// };

// export default WritableParametersTab;

import React, { useEffect, useState, useCallback, useMemo } from "react";
import {
  Table, Button, Input, InputNumber, Switch, Modal, Form,
  message, Tooltip, Popconfirm, Space, Tag, Typography, Select, TreeSelect,
} from "antd";
import {
  PlusOutlined, SaveOutlined, EditOutlined, DeleteOutlined,
  LockOutlined,
} from "@ant-design/icons";
import { getWriteParameters, saveWriteParameters } from "../service/Writecontrol";

const { Text } = Typography;

/**
 * Tab displayed on the Asset detail / edit page.
 * Lets the customer select which parameters are allowed for MQTT write operations.
 *
 * Props:
 *   assetUuid        – UUID of the asset
 *   sampleJson       – parsed sample JSON from the asset (used to suggest param keys)
 */
const WritableParametersTab = ({ assetUuid, parsedJson }) => {
  const [params, setParams] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingParam, setEditingParam] = useState(null);
  const [form] = Form.useForm();

  // ── Build TreeSelect data from parsedJson — same as Select Key in machineForm ──
  const treeData = useMemo(() => {
    const buildTree = (obj, prefix = "") => {
      if (!obj || typeof obj !== "object") return [];
      return Object.entries(obj)
        .filter(([k]) => k !== "timestamp")
        .map(([k, v]) => {
          const path = prefix ? `${prefix}.${k}` : k;
          if (typeof v === "object" && v !== null) {
            return { title: k, value: path, children: buildTree(v, path) };
          }
          return { title: k, value: path };
        });
    };
    try {
      const obj = typeof parsedJson === "string" ? JSON.parse(parsedJson) : parsedJson || {};
      return buildTree(obj);
    } catch {
      return [];
    }
  }, [parsedJson]);

  // ── Load existing configuration ──────────────────────────────────────────
  const loadParams = useCallback(async () => {
    if (!assetUuid) return;
    setLoading(true);
    try {
      const res = await getWriteParameters(assetUuid);
      setParams(res?.data?.data || []);
    } catch (err) {
      message.error("Failed to load writable parameters");
    } finally {
      setLoading(false);
    }
  }, [assetUuid]);

  useEffect(() => {
    loadParams();
  }, [loadParams]);

  // ── Save all parameters ───────────────────────────────────────────────────
  const handleSave = async () => {
    setSaving(true);
    try {
      await saveWriteParameters(assetUuid, params);
      message.success("Writable parameters saved");
    } catch (err) {
      message.error("Failed to save");
    } finally {
      setSaving(false);
    }
  };

  // ── Add / edit modal ──────────────────────────────────────────────────────
  const openAdd = () => {
    setEditingParam(null);
    form.resetFields();
    form.setFieldsValue({ enabled: true });
    setModalOpen(true);
  };

  const openEdit = (record) => {
    setEditingParam(record);
    form.setFieldsValue(record);
    setModalOpen(true);
  };

  const handleModalOk = async () => {
    const values = await form.validateFields();
    let newParams;
    if (editingParam) {
      newParams = params.map((p) =>
        p.parameterKey === editingParam.parameterKey ? { ...p, ...values } : p
      );
    } else {
      if (params.some((p) => p.parameterKey === values.parameterKey)) {
        message.warning("Parameter key already added");
        return;
      }
      newParams = [...params, { ...values, enabled: values.enabled ?? true }];
    }
    setParams(newParams);
    setModalOpen(false);
    // Auto-save immediately after add/edit
    setSaving(true);
    try {
      await saveWriteParameters(assetUuid, newParams);
      message.success("Writable parameter saved");
    } catch (err) {
      message.error("Failed to save: " + (err?.response?.data?.message || err.message));
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (parameterKey) => {
    const newParams = params.filter((p) => p.parameterKey !== parameterKey);
    setParams(newParams);
    // Auto-save after delete
    setSaving(true);
    try {
      await saveWriteParameters(assetUuid, newParams);
      message.success("Parameter removed");
    } catch (err) {
      message.error("Failed to save: " + (err?.response?.data?.message || err.message));
    } finally {
      setSaving(false);
    }
  };

  const toggleEnabled = async (parameterKey, enabled) => {
    const newParams = params.map((p) =>
      p.parameterKey === parameterKey ? { ...p, enabled } : p
    );
    setParams(newParams);
    // Auto-save after toggle
    setSaving(true);
    try {
      await saveWriteParameters(assetUuid, newParams);
      message.success(enabled ? "Parameter enabled" : "Parameter disabled");
    } catch (err) {
      message.error("Failed to save: " + (err?.response?.data?.message || err.message));
    } finally {
      setSaving(false);
    }
  };

  // ── Table columns ─────────────────────────────────────────────────────────
  const columns = [
    {
      title: "Parameter Key",
      dataIndex: "parameterKey",
      key: "parameterKey",
      render: (v) => <Text code>{v}</Text>,
    },
    {
      title: "Display Name",
      dataIndex: "displayName",
      key: "displayName",
    },
    {
      title: "Unit",
      dataIndex: "unit",
      key: "unit",
      render: (v) => v ? <Tag>{v}</Tag> : "—",
    },
    {
      title: "Min",
      dataIndex: "minValue",
      key: "minValue",
      render: (v) => (v != null ? v : "—"),
    },
    {
      title: "Max",
      dataIndex: "maxValue",
      key: "maxValue",
      render: (v) => (v != null ? v : "—"),
    },
    {
      title: "Enabled",
      dataIndex: "enabled",
      key: "enabled",
      render: (v, record) => (
        <Switch
          checked={v}
          size="small"
          onChange={(checked) => toggleEnabled(record.parameterKey, checked)}
        />
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Tooltip title="Edit">
            <Button
              icon={<EditOutlined />}
              size="small"
              onClick={() => openEdit(record)}
            />
          </Tooltip>
          <Popconfirm
            title="Remove this writable parameter?"
            onConfirm={() => handleDelete(record.parameterKey)}
            okText="Remove"
            okButtonProps={{ danger: true }}
          >
            <Tooltip title="Remove">
              <Button icon={<DeleteOutlined />} size="small" danger />
            </Tooltip>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div>
      {/* Header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 16,
          padding: "12px 16px",
          background: "#fff7e6",
          borderRadius: 8,
          border: "1px solid #ffd591",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <LockOutlined style={{ color: "#fa8c16", fontSize: 18 }} />
          <div>
            <Text strong>Write-Permitted Parameters</Text>
            <br />
            <Text type="secondary" style={{ fontSize: 12 }}>
              Only parameters listed here can be written via MQTT. This is a
              security boundary — add carefully.
            </Text>
          </div>
        </div>
        <Space>
          <Button icon={<PlusOutlined />} onClick={openAdd}>
            Add Parameter
          </Button>
          {saving && (
            <Text type="secondary" style={{ fontSize: 12 }}>
              <SaveOutlined spin /> Saving...
            </Text>
          )}
        </Space>
      </div>

      {/* Table */}
      <Table
        dataSource={params}
        columns={columns}
        rowKey="parameterKey"
        loading={loading}
        pagination={false}
        size="small"
        locale={{ emptyText: "No writable parameters configured. Click 'Add Parameter' to start." }}
      />

      {/* Add/Edit Modal */}
      <Modal
        title={editingParam ? "Edit Writable Parameter" : "Add Writable Parameter"}
        open={modalOpen}
        onOk={handleModalOk}
        onCancel={() => setModalOpen(false)}
        okText="Save"
        destroyOnClose
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="parameterKey"
            label="Parameter Key"
            rules={[{ required: true, message: "Required" }]}
          >
            <TreeSelect
              treeData={treeData}
              placeholder="Select parameter key"
              disabled={!!editingParam}
              treeDefaultExpandAll
              showSearch
              allowClear
              style={{ width: "100%" }}
              onChange={(val) => {
                // Auto-fill displayName with last segment if empty
                const lastSegment = val ? val.split(".").pop() : "";
                if (!form.getFieldValue("displayName")) {
                  form.setFieldsValue({ displayName: lastSegment });
                }
              }}
            />
          </Form.Item>

          <Form.Item name="displayName" label="Display Name">
            <Input placeholder="e.g. Furnace Temperature" />
          </Form.Item>

          <Form.Item name="unit" label="Unit">
            <Input placeholder="e.g. °C, bar, rpm" style={{ width: 160 }} />
          </Form.Item>

          <div style={{ display: "flex", gap: 16 }}>
            <Form.Item name="minValue" label="Min Value" style={{ flex: 1 }}>
              <InputNumber style={{ width: "100%" }} placeholder="Optional" />
            </Form.Item>
            <Form.Item name="maxValue" label="Max Value" style={{ flex: 1 }}>
              <InputNumber style={{ width: "100%" }} placeholder="Optional" />
            </Form.Item>
          </div>

          <Form.Item name="enabled" label="Enabled" valuePropName="checked">
            <Switch />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default WritableParametersTab;